export enum VirtualTerminalProxyFormFieldNamesEnum {
  Amount = 'amount',
  InvoiceNumber = 'invoiceNumber',
  Notes = 'notes',
  Customer = 'customer',
  CustomerCard = 'customerCard',
  AchAccount = 'achAccount',
  StreetAddressOne = 'streetAddressOne',
  StreetAddressTwo = 'streetAddressTwo',
  City = 'city',
  State = 'state',
  PostalCode = 'postalCode',
  CountryCode = 'countryCode',
  Email = 'email'
}
